<template>
  <el-select v-model="value" placeholder="地区筛选" clearable @change="onChange">
    <el-option v-for="(item, index) in options" :key="index" :label="item" :value="item" />
  </el-select>
</template>

<script>
export default {
  data () {
    return {
      value: this.current,
      options: []
    }
  },
  props: {
    current: { type: String, default: null },
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.$apis.trend.region.metas().then(res => {
        this.options = res
      }).catch(e => {
        this.$message.error(e)
      })
    },
    onChange (val) {
      this.$emit('update:current', val)
    }
  }
}
</script>

